import styled from 'styled-components/native';
import { View } from 'react-native';
import { get } from '../utils/theme.utils';

export const Separator = styled(View)`
  width: ${get('size', 30)}px;
  height: ${get('size', 30)}px;
`;
